
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/rewards",
      function () {
        return require("private-next-pages/mobiworkx/rewards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/rewards"])
      });
    }
  